import { REACTION_EMOJI } from '@shared/live.ts'
import { type Component, For } from 'solid-js'
import type { ReactionBurst } from '~/lib/live-store'

type Props = {
  bursts: ReactionBurst[]
}

/**
 * リアクションの粒を映像の上に飛ばす層（要件定義 17 章）。
 *
 * 要件定義 3.3「Player の UI を不必要に隠さない」/ 14 章「帰属表示を不当に隠さない」に
 * 触れないよう、次を必ず守る。
 *
 * - 下端を空ける（YouTube のコントロールと帰属表示が出る帯）
 * - pointer-events を持たない（Player の操作をひとつも奪わない）
 * - 粒は 2.4 秒で消える。画面に居座るものは何も置かない
 * - 動きを減らす設定の環境では出さない（src/index.css）
 *
 * 実況そのものを映像に重ねること（弾幕）はしない。
 * 常時ほとんどの面を覆うことになり、上の条件を満たせないため。
 */
export const ReactionOverlay: Component<Props> = (props) => (
  <div
    class="burst-stage pointer-events-none absolute inset-x-0 bottom-12 top-0 z-20 overflow-hidden"
    aria-hidden="true"
  >
    <For each={props.bursts}>
      {(burst) => (
        <span
          class="burst-item absolute bottom-0 text-xl sm:text-2xl"
          // 過去の放送ぶんは薄くする。いま誰かが押したものと同じには見せない
          classList={{ 'opacity-40': burst.replay }}
          // 粒ごとに横位置をずらす。id から決めているので、描き直しても動かない
          style={{ right: `${4 + ((burst.id * 37) % 18)}%` }}
        >
          {REACTION_EMOJI[burst.kind]}
        </span>
      )}
    </For>
  </div>
)
